import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the quantity of the given `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#customlineitem"
        }}>{`CustomLineItem`}</a>{`.`}</p>
      <p parentName="section">{`ChangeCustomLineItemQuantity does not support changing the shipping details when multiple shipping addresses are set for one custom line item. `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#add-customlineitem"
        }}>{`AddCustomLineItem`}</a>{` supports this.
This is the case because it is not possible to deduct how the distribution of sub-quantities should be adapted in accordance with the overall change in the custom line item quantity.
Thus, the `}<inlineCode parentName="p">{`shippingDetails`}</inlineCode>{` field will be kept in its current state to avoid data loss.
Use `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#set-customlineitemshippingdetails"
        }}>{`SetCustomLineItemShippingDetails`}</a>{` in combination with this update action in one cart update command to change the custom line item quantity and shipping details together.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeCustomLineItemQuantity"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`customLineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#customlineitem"
          }}>{`CustomLineItem`}</a>{` in the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`quantity`}</inlineCode>{` - Number - Required`}<br parentName="li"></br>
          {`The new quantity being a value >= 0. If quantity is `}<inlineCode parentName="li">{`0`}</inlineCode>{`, the custom line item will be removed from the cart.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      